import { Box, styled } from "@mui/material";

export const BackgroundContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '75vh',
  textAlign: 'center',
  color: theme.palette.common.white,
  zIndex: 2,
  overflow: 'hidden',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url('/laundromatPicture.JPG')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: "center 20%",
    filter: 'blur(2px)',
    zIndex: -1,
  },
  borderBottomLeftRadius: '60% 20%',
  borderBottomRightRadius: '60% 20%',
}));